import { tagsActions } from '@src/store/reducers/tagTypesReducer';

const initState = null;

export const tagsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case tagsActions.GET_OBJECT_TAGS:
            return action.payload;

        case tagsActions.REFRESH_DELETE_TAG:
            return state.filter((item: any) => item.name != action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/tagsReducer.ts